import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { SingleSelectTagWithoutOptionsFragmentDoc } from './SingleSelectTagWithoutOptions';
import { SharedByWorkspaceFragmentDoc } from '../../../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { TagControlConfigFragmentDoc } from './TagControlConfig';
export type SingleSelectTagFragment = { id: string, name: string, description?: string | null, availableOn: Array<Types.TagAvailableOnEnum>, type: Types.TagTypeEnum, subWorkspaces?: Array<string> | null, category?: Types.TagCategoryEnum | null, source?: string | null, subType?: Types.TagSubTypeEnum | null, options: Array<{ id: string, name: string }>, settings: { availableInLibrary: boolean, requiredTag: boolean, controlConfig?: { controls: Array<{ controllingEntity: { type: Types.TagControlSourcePropertyTypeEnum, value: string }, rules: Array<{ source: { operator: Types.TagControlOperatorEnum, values: Array<string> }, target: { operator: Types.TagControlOperatorEnum, values: Array<string> } }> }> } | null, iconSettings: { type: Types.IconTypeEnum, value: string } }, createdBy?: { id: string, name?: string | null } | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null };


export type SingleSelectTagFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SingleSelectTagFragmentDoc = /*#__PURE__*/ gql`
    fragment SingleSelectTag on SingleSelectTagType {
  ...SingleSelectTagWithoutOptions
  options {
    id
    name
  }
  settings {
    controlConfig {
      ...TagControlConfig
    }
  }
}
    `;